import axios from 'axios';
import Swal from 'sweetalert2';

document.querySelector('#pgoServiceRequestPrivate') && new Vue({
    el: '#pgoServiceRequestPrivate',
    data: function () {
        return {
            date_of_request: null,
            item: null,
            make: null,
            model: null,
            plate_no: null,
            quantity: 1,
            selected_items: [

            ],
            gas_slip: null,
        };
    },
    methods: {
        add() {
            if (this.item == null) {
                return;
            }

            var item = serviceItems.find((a) => a.id == this.item);
            this.selected_items.push({
                item: item,
                quantity: this.quantity,
            });
        },
        removeItem(idx) {
            this.selected_items = this.selected_items.filter((a, b) => b != idx);
        },
        showConfirmationModal() {
            try {
                if (this.date_of_request == null) {
                    throw 'Please enter date of request';
                }

                if (this.make == null) {
                    throw 'Make is required';
                }

                if (this.model == null) {
                    throw 'Model is required';
                }

                if (this.plate_no == null) {
                    throw 'Plate No is required';
                }

                if (this.selected_items.length == 0) {
                    throw 'No items added';
                }

                $('#confirmationModal').modal('show');

            } catch (e) {
                new Swal('Error', e, 'error');
            }


        },
        print() { },
        async submit() {
            try {
                var res = await axios.post('/pgo/service-requests', {
                    date_of_request: this.date_of_request,
                    make: this.make,
                    model: this.model,
                    plate_no: this.plate_no,
                    selected_items: this.selected_items,
                });

                this.date_of_request = null;
                this.selected_items = [];

                $('#confirmationModal').modal('hide');

                new Swal('Success!', 'Lubricants/Service request submitted successfully', 'success');


            } catch (e) {
                new Swal('Error', e, 'error');
            }
        }
    },
    mounted() {
    }
});